[class*=" font-preview-"],
[class^="font-preview-"] {
  background-size: 30em auto;
  background-repeat: no-repeat;
  height: 2em;
  image-rendering: optimizequality;
}
.font-preview-abril_fatface,
.font-preview-alegreya,
.font-preview-alegreya_sans,
.font-preview-archivo_narrow,
.font-preview-azeret_mono,
.font-preview-bad_script,
.font-preview-biorhyme,
.font-preview-bitter,
.font-preview-cardo,
.font-preview-chivo,
.font-preview-comic_neue,
.font-preview-cormorant,
.font-preview-dancing_script,
.font-preview-dm_sans,
.font-preview-dm_serif_display,
.font-preview-on-all {
  background-image: url(sprite.1.svg);
}
.font-preview-dm_serif_text,
.font-preview-eczar,
.font-preview-familjen_grotesk,
.font-preview-fira_sans,
.font-preview-fraunces,
.font-preview-ibm_plex_sans,
.font-preview-inconsolata,
.font-preview-inknut_antiqua,
.font-preview-inter,
.font-preview-josefin_sans,
.font-preview-josefin_slab,
.font-preview-karla,
.font-preview-lato,
.font-preview-libre_baskerville,
.font-preview-libre_franklin,
.font-preview-on-all {
  background-image: url(sprite.2.svg);
}
.font-preview-literata,
.font-preview-lora,
.font-preview-manrope,
.font-preview-merriweather,
.font-preview-montserrat,
.font-preview-mukta,
.font-preview-neuton,
.font-preview-new_rocker,
.font-preview-newsreader,
.font-preview-noto_sans_jp,
.font-preview-nunito,
.font-preview-nunito_sans,
.font-preview-old_standard_tt,
.font-preview-open_sans,
.font-preview-oswald,
.font-preview-on-all {
  background-image: url(sprite.3.svg);
}
.font-preview-outfit,
.font-preview-overpass,
.font-preview-playfair_display,
.font-preview-plus_jakarta_sans,
.font-preview-poppins,
.font-preview-proza_libre,
.font-preview-pt_sans,
.font-preview-pt_serif,
.font-preview-rajdhani,
.font-preview-raleway,
.font-preview-roboto,
.font-preview-roboto_condensed,
.font-preview-roboto_mono,
.font-preview-roboto_serif,
.font-preview-roboto_slab,
.font-preview-on-all {
  background-image: url(sprite.4.svg);
}
.font-preview-rubik,
.font-preview-sacramento,
.font-preview-source_sans_3,
.font-preview-source_serif_4,
.font-preview-space_grotesk,
.font-preview-space_mono,
.font-preview-spectral,
.font-preview-syne,
.font-preview-tangerine,
.font-preview-ubuntu,
.font-preview-ultra,
.font-preview-unifrakturmaguntia,
.font-preview-varela_round,
.font-preview-work_sans,
.font-preview-zilla_slab,
.font-preview-on-all {
  background-image: url(sprite.5.svg);
}
.font-preview-abril_fatface{ background-position: 0px -0em }
.font-preview-alegreya{ background-position: 0px -2em }
.font-preview-alegreya_sans{ background-position: 0px -4em }
.font-preview-archivo_narrow{ background-position: 0px -6em }
.font-preview-azeret_mono{ background-position: 0px -8em }
.font-preview-bad_script{ background-position: 0px -10em }
.font-preview-biorhyme{ background-position: 0px -12em }
.font-preview-bitter{ background-position: 0px -14em }
.font-preview-cardo{ background-position: 0px -16em }
.font-preview-chivo{ background-position: 0px -18em }
.font-preview-comic_neue{ background-position: 0px -20em }
.font-preview-cormorant{ background-position: 0px -22em }
.font-preview-dancing_script{ background-position: 0px -24em }
.font-preview-dm_sans{ background-position: 0px -26em }
.font-preview-dm_serif_display{ background-position: 0px -28em }
.font-preview-dm_serif_text{ background-position: 0px -0em }
.font-preview-eczar{ background-position: 0px -2em }
.font-preview-familjen_grotesk{ background-position: 0px -4em }
.font-preview-fira_sans{ background-position: 0px -6em }
.font-preview-fraunces{ background-position: 0px -8em }
.font-preview-ibm_plex_sans{ background-position: 0px -10em }
.font-preview-inconsolata{ background-position: 0px -12em }
.font-preview-inknut_antiqua{ background-position: 0px -14em }
.font-preview-inter{ background-position: 0px -16em }
.font-preview-josefin_sans{ background-position: 0px -18em }
.font-preview-josefin_slab{ background-position: 0px -20em }
.font-preview-karla{ background-position: 0px -22em }
.font-preview-lato{ background-position: 0px -24em }
.font-preview-libre_baskerville{ background-position: 0px -26em }
.font-preview-libre_franklin{ background-position: 0px -28em }
.font-preview-literata{ background-position: 0px -0em }
.font-preview-lora{ background-position: 0px -2em }
.font-preview-manrope{ background-position: 0px -4em }
.font-preview-merriweather{ background-position: 0px -6em }
.font-preview-montserrat{ background-position: 0px -8em }
.font-preview-mukta{ background-position: 0px -10em }
.font-preview-neuton{ background-position: 0px -12em }
.font-preview-new_rocker{ background-position: 0px -14em }
.font-preview-newsreader{ background-position: 0px -16em }
.font-preview-noto_sans_jp{ background-position: 0px -18em }
.font-preview-nunito{ background-position: 0px -20em }
.font-preview-nunito_sans{ background-position: 0px -22em }
.font-preview-old_standard_tt{ background-position: 0px -24em }
.font-preview-open_sans{ background-position: 0px -26em }
.font-preview-oswald{ background-position: 0px -28em }
.font-preview-outfit{ background-position: 0px -0em }
.font-preview-overpass{ background-position: 0px -2em }
.font-preview-playfair_display{ background-position: 0px -4em }
.font-preview-plus_jakarta_sans{ background-position: 0px -6em }
.font-preview-poppins{ background-position: 0px -8em }
.font-preview-proza_libre{ background-position: 0px -10em }
.font-preview-pt_sans{ background-position: 0px -12em }
.font-preview-pt_serif{ background-position: 0px -14em }
.font-preview-rajdhani{ background-position: 0px -16em }
.font-preview-raleway{ background-position: 0px -18em }
.font-preview-roboto{ background-position: 0px -20em }
.font-preview-roboto_condensed{ background-position: 0px -22em }
.font-preview-roboto_mono{ background-position: 0px -24em }
.font-preview-roboto_serif{ background-position: 0px -26em }
.font-preview-roboto_slab{ background-position: 0px -28em }
.font-preview-rubik{ background-position: 0px -0em }
.font-preview-sacramento{ background-position: 0px -2em }
.font-preview-source_sans_3{ background-position: 0px -4em }
.font-preview-source_serif_4{ background-position: 0px -6em }
.font-preview-space_grotesk{ background-position: 0px -8em }
.font-preview-space_mono{ background-position: 0px -10em }
.font-preview-spectral{ background-position: 0px -12em }
.font-preview-syne{ background-position: 0px -14em }
.font-preview-tangerine{ background-position: 0px -16em }
.font-preview-ubuntu{ background-position: 0px -18em }
.font-preview-ultra{ background-position: 0px -20em }
.font-preview-unifrakturmaguntia{ background-position: 0px -22em }
.font-preview-varela_round{ background-position: 0px -24em }
.font-preview-work_sans{ background-position: 0px -26em }
.font-preview-zilla_slab{ background-position: 0px -28em }